'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var appType = require('../../types/appTypes');
var projectLoadHelper = require('../../helper/projectLoadHelper');
var graphicsHelper = require('./../../helper/graphicsHelper.js');
var _ = require('underscore');
var util = require('../../helper/util');

/**
 * Image2
 * @author mxj
 * @createDate 2016/9/22
 **/

var Image = React.createClass({

  propTypes: {},

  src: undefined,

  render: function () {
    /*
     1、计算出图片摆正时的宽高，然后所有组件默认都以这个尺寸时行显示绘制
     2、根据当前旋转角度，翻转方向计算出transform，并施加到此组件的 border 上
     */
    var style = {
      left: 0,
      top: 0
    };
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var defaultRotateAngle = styleHelper.getOriginalProperty(this.props, propConst.ROTATION_ANGLE);
    // var rotateAngle = styleHelper.getStateProperty(this.props, propConst.ROTATION_ANGLE);
    var rotateAngle = styleHelper.getPropertyValue(this.props, propConst.ROTATION_ANGLE);
    var defaultW = w;
    var defaultH = h;
    var flipHorizontal = styleHelper.getPropertyValue(this.props, propConst.FLIP_HORIZONTAL);
    var flipVertical = styleHelper.getPropertyValue(this.props, propConst.FLIP_VERTICAL);
    var rx = 0;
    var ry = 0;
    var rz = 0;
    var offset;
    var transform;
    var transformOrigin;
    var rotate3D;
    var translate;
    var src;
    var url = styleHelper.getPropertyValue(this.props, propConst.URL);
    var canvasStyle = {};
    if (this.props.radiusIsPercent) {
      canvasStyle.borderRadius = parseInt(this.props.radius, 10) / 2 + '%';
    } else {
      canvasStyle.borderRadius = this.props.radius;
    }

    this.isEmptyImage = _.isEmpty(url);

    if (!this.isEmptyImage) {
      if (!this.src) {
        this.src = src = projectLoadHelper.loadImage(url);
      } else {
        src = this.src;
      }
    }
    offset = (defaultH - defaultW) / 2;
    if (defaultRotateAngle === appType.RotationAngle.NINETY || defaultRotateAngle === appType.RotationAngle.TWO_HUNDRED_SEVENTY) {
      defaultW = h;
      defaultH = w;
    }

    style.width = defaultW;
    style.height = defaultH;


    if (!rotateAngle || rotateAngle === appType.RotationAngle.ZERO) {
      switch (defaultRotateAngle) {
      case appType.RotationAngle.NINETY:
        transform = 'rotate(90deg)';
        translate = 'translate(' + offset + 'px, ' + offset + 'px)';
        break;
      case appType.RotationAngle.ONE_HUNDRED_EIGHTY:
        transform = 'rotate(180deg)';
        translate = '';
        break;
      case appType.RotationAngle.TWO_HUNDRED_SEVENTY:
        transform = 'rotate(270deg)';
        translate = 'translate(' + -offset + 'px,' + -offset + 'px)';
        break;
      }
      if (!rotateAngle || rotateAngle !== defaultRotateAngle) {
        if (transform) {
          transform += (' ' + translate);
        }
      }
    } else {
      switch (rotateAngle) {
      case appType.RotationAngle.NINETY:
        transform = 'rotate(90deg)';
        translate = 'translate(' + offset + 'px,' + offset + 'px)';
        break;
      case appType.RotationAngle.ONE_HUNDRED_EIGHTY:
        transform = 'rotate(180deg)';
        translate = '';
        break;
      case appType.RotationAngle.TWO_HUNDRED_SEVENTY:
        transform = 'rotate(270deg)';
        translate = 'translate(' + -offset + 'px,' + -offset + 'px)';
        break;
      }
      if (defaultRotateAngle) {
        if (transform && translate) {
          if (rotateAngle === defaultRotateAngle)
            transform += (' ' + translate);
        }
      }
    }
    if (flipHorizontal) {
      ry = 1;
    }
    if (flipVertical) {
      rx = 1;
    }
    if (flipHorizontal && flipVertical) {
      rz = 1;
      rx = ry = 0;
    }

    if (rx || ry || rz) {
      rotate3D = 'rotate3D(' + [rx, ry, rz, '180deg'].join(',') + ')';
      //if (transform) {
      //  transform += (' ' + rotate3D);
      //} else {
      //  transform = rotate3D;
      //}
      canvasStyle.transformOrigin = 'center center';
      canvasStyle.transform = rotate3D;
    }

    if (!_.isUndefined(transform)) {
      style.transform = transform;
      transformOrigin = 'center center';
      style.transformOrigin = transformOrigin;
    }
    return (
      <div ref="border" className="border" style={style}>
        <canvas ref="ctx" width={defaultW} height={defaultH} style={canvasStyle}>
          {
            !this.isEmptyImage && <img ref="img" onLoad={this._onImageLoaded} src={src}/>
          }
        </canvas>
      </div>
    );
  },

  _onImageLoaded: function (e) {
    this.imageLoaded = true;
    this.doPaint();
  },

  componentDidMount: function () {
    this.doPaint();
  },

  componentDidUpdate: function () {
    this.doPaint();
  },

  paintEmpty: function (canvas) {
    var g = canvas.getContext('2d');
    var w = canvas.width;
    var h = canvas.height;
    var caption = styleHelper.getPropertyValue(this.props, propConst.CAPTION);
    g.clearRect(0, 0, w, h);
    g.beginPath();
    g.strokeStyle = '#444';

    g.fillStyle = '#fff';
    g.lineWidth = 1;

    var shapeType = styleHelper.getPropertyValue(this.props, 'clipShapeType');
    if(shapeType === 'SbEllipse') {
      graphicsHelper.drawEllipse(g, w, h, '#444');
    } else {
      g.rect(0.5, 0.5, w - 1, h - 1);
      g.closePath();

      g.fill();
      g.stroke();
    }

    var xLinePadding = 2;
    var yLinePadding = 2;
    if(shapeType === 'SbEllipse') {
      xLinePadding = Math.round(w * 0.2);
      yLinePadding = Math.round(h * 0.2);
    }
    g.moveTo(xLinePadding, yLinePadding);
    g.lineTo(w - xLinePadding, h - yLinePadding);
    g.moveTo(xLinePadding, h - yLinePadding);
    g.lineTo(w - xLinePadding, yLinePadding);
    g.stroke();

    if (this.props.showText) {
      var bgSize = 28;
      var captionSize = g.measureText(caption);
      var fontSize = 8;
      if (captionSize.width + 8 < w && fontSize + 5 < h) {
        g.fillRect(w / 2 - bgSize / 2, h / 2 - bgSize / 2, bgSize, bgSize);
        g.font = fontSize + 'px Arial';
        g.fillStyle = '#000';
        g.fillText(caption, w / 2 - captionSize.width / 2, h / 2 + fontSize / 2);
      }
    }
  },

  doPaint: function () {
    var canvas = ReactDOM.findDOMNode(this.refs.ctx);
    var img;
    if (this.isEmptyImage) {
      this.paintEmpty(canvas);
    } else {
      img = ReactDOM.findDOMNode(this.refs.img);
      this.paintImage(canvas, img);
    }
  },

  paintImage: function (canvas, img) {
    var g = canvas.getContext('2d');
    var w = canvas.width;
    var h = canvas.height;
    var filterType = styleHelper.getPropertyValue(this.props, propConst.FILTER_TYPE);
    var shapeType = styleHelper.getPropertyValue(this.props, propConst.CLIP_SHAPE_TYPE);
    var radius = styleHelper.getRadius(this.props);
    var filterValue;
    var fitMode = styleHelper.getInt(this.props, propConst.FIT_MODE);
    var isRepeat = fitMode === appType.ImageFitMode.TILE;
    var self = this;
    if (!this.imageLoaded) {
      return;
    }
    if (filterType === appType.ImageFilter.PENCIL) {
      filterValue = styleHelper.getInt(this.props, propConst.FILTER_PENCIL_VALUE);
    } else if (filterType === appType.ImageFilter.SKETCH) {
      filterValue = styleHelper.getInt(this.props, propConst.FILTER_SKETCH_VALUE);
    }

    graphicsHelper
      .drawFilterImage(g,
        img,
        {
          left: 0,
          top: 0,
          right: w,
          bottom: h
        },
        isRepeat,
        {
          // filterType: filterType,
          // filterValue: filterValue
        },
        {
          shapeType: shapeType,
          radius: radius,
          borderVisible: styleHelper.getBorderVisible(this.props)
        },
        function () {
          if (filterType !== appType.ImageFilter.NONE) {
            // canvas.className = 'grayImage';
          }
        });
  },

  doClipErrorImage: function () {
    var border = ReactDOM.findDOMNode(this.refs.border);
    var shapeType = styleHelper.getPropertyValue(this.props, propConst.CLIP_SHAPE_TYPE);
    var radius = styleHelper.getRadius(this.props);
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var style;
    if (shapeType === appType.ShapeType.RECTANGLE) {
      style = {
        'border-radius': radius + 'px',
        'border': '0px solid'
      }
    } else if (shapeType === appType.ShapeType.ELLIPSE) {
      style = {
        'border': '0px solid',
        'border-top-left-radius': w / 2 + 'px ' + h / 2 + 'px'
      };
      style['border-top-right-radius'] = style['border-bottom-left-radius'] = style['border-bottom-right-radius'] = style['border-top-left-radius'];
    }
    if (style) {
      $(border).css(style)
    }
  }/*,

   doClipErrorImage : function(){
   var border = ReactDOM.findDOMNode(this.refs.border);
   var shapeType = styleHelper.getPropertyValue(this.props, propConst.CLIP_SHAPE_TYPE);
   var radius = styleHelper.getRadius(this.props);
   var w = styleHelper.getWidth(this.props);
   var h = styleHelper.getHeight(this.props);
   var style;
   if(shapeType === appType.ShapeType.RECTANGLE){
   style = {
   'border-radius' : radius + 'px',
   'border' : '0px solid'
   }
   }else if(shapeType === appType.ShapeType.ELLIPSE){
   style={
   'border' : '0px solid',
   'border-top-left-radius' : w/2 + 'px ' + h/2 + 'px'
   };
   style['border-top-right-radius'] = style['border-bottom-left-radius'] = style['border-bottom-right-radius'] = style['border-top-left-radius'];
   }
   if(style){
   $(border).css(style)
   }
   }*/
});

module.exports = Image;


// WEBPACK FOOTER //
// ./src/views/Components/Image.jsx